"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _jsxFileName = "/builds/schumacherweb/devbridge/ui-shared/549481182/shared/src/theme/icons/files/google-store.svg.js",
    _linearGradient,
    _linearGradient2,
    _linearGradient3,
    _linearGradient4,
    _path,
    _path2,
    _path3,
    _path4,
    _path5,
    _path6,
    _path7,
    _path8,
    _path9,
    _path10,
    _path11;

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ReactComponent(props) {
  return React.createElement("svg", (0, _extends2["default"])({
    height: 40,
    viewBox: "0 0 135 40",
    width: 135,
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: this
  }), _linearGradient || (_linearGradient = React.createElement("linearGradient", {
    id: "prefix__a",
    gradientUnits: "userSpaceOnUse",
    x1: 21.802,
    x2: 5.022,
    y1: 8.713,
    y2: 25.492,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: this
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "#00a0ff",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 14
    },
    __self: this
  }), React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00a1ff",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 15
    },
    __self: this
  }), React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00beff",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 16
    },
    __self: this
  }), React.createElement("stop", {
    offset: 0.51,
    stopColor: "#00d2ff",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 17
    },
    __self: this
  }), React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00dfff",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 18
    },
    __self: this
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#00e3ff",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 19
    },
    __self: this
  }))), _linearGradient2 || (_linearGradient2 = React.createElement("linearGradient", {
    id: "prefix__b",
    gradientUnits: "userSpaceOnUse",
    x1: 33.83,
    x2: 9.64,
    y1: 20,
    y2: 20,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 21
    },
    __self: this
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe000",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 29
    },
    __self: this
  }), React.createElement("stop", {
    offset: 0.41,
    stopColor: "#ffbd00",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 30
    },
    __self: this
  }), React.createElement("stop", {
    offset: 0.78,
    stopColor: "orange",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 31
    },
    __self: this
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9c00",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 32
    },
    __self: this
  }))), _linearGradient3 || (_linearGradient3 = React.createElement("linearGradient", {
    id: "prefix__c",
    gradientUnits: "userSpaceOnUse",
    x1: 24.828,
    x2: 2.067,
    y1: 22.297,
    y2: 45.047,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 34
    },
    __self: this
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3a44",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 42
    },
    __self: this
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#c31162",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 43
    },
    __self: this
  }))), _linearGradient4 || (_linearGradient4 = React.createElement("linearGradient", {
    id: "prefix__d",
    gradientUnits: "userSpaceOnUse",
    x1: 7.298,
    x2: 17.457,
    y1: 0.182,
    y2: 10.342,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 45
    },
    __self: this
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "#32a071",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 53
    },
    __self: this
  }), React.createElement("stop", {
    offset: 0.07,
    stopColor: "#2da771",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 54
    },
    __self: this
  }), React.createElement("stop", {
    offset: 0.48,
    stopColor: "#15cf74",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 55
    },
    __self: this
  }), React.createElement("stop", {
    offset: 0.8,
    stopColor: "#06e775",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 56
    },
    __self: this
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#00f076",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 57
    },
    __self: this
  }))), _path || (_path = React.createElement("path", {
    d: "M5 0h125c2.8 0 5 2.2 5 5v30c0 2.8-2.2 5-5 5H5c-2.8 0-5-2.2-5-5V5c0-2.8 2.2-5 5-5z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 59
    },
    __self: this
  })), _path2 || (_path2 = React.createElement("path", {
    d: "M130 .8c2.3 0 4.2 1.9 4.2 4.2v30c0 2.3-1.9 4.2-4.2 4.2H5C2.7 39.2.8 37.3.8 35V5C.8 2.7 2.7.8 5 .8zm0-.8H5C2.2 0 0 2.2 0 5v30c0 2.8 2.2 5 5 5h125c2.8 0 5-2.2 5-5V5c0-2.8-2.2-5-5-5z",
    fill: "#a6a6a6",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 60
    },
    __self: this
  })), _path3 || (_path3 = React.createElement("path", {
    d: "M47.4 10.2c0 .7-.2 1.5-.8 2-.6.6-1.4.9-2.2.9-1.7 0-3.1-1.4-3.1-3.2 0-.8.3-1.6.9-2.2s1.4-.9 2.2-.9c.4 0 .8.1 1.2.2s.7.4.9.7l-.5.5c-.4-.5-1-.7-1.6-.7-1.3 0-2.3 1-2.3 2.3v.1c0 1.3 1 2.4 2.3 2.4.6 0 1.2-.2 1.7-.7.3-.3.5-.8.5-1.2h-2.2v-.6h2.9c.1.1.1.3.1.4zM52 7.7h-2.7v1.9h2.5v.7h-2.5v1.9H52v.8h-3.5V7H52zm3.3 5.3h-.8V7.7h-1.7V7H57v.7h-1.7zm4.6 0V7h.8v6zm4.2 0h-.8V7.7h-1.7V7h4.1v.7H64zm9.5-.8c-1.2 1.2-3.2 1.2-4.4 0S68 9 69.2 7.8s3.2-1.2 4.4 0c1.2 1.2 1.2 3.2 0 4.4zm-3.8-.5c.9.9 2.4.9 3.3 0 .9-1 .9-2.5 0-3.4s-2.4-.9-3.3 0c-.9 1-.9 2.4 0 3.4zm5.8 1.3V7h.9l2.9 4.7V7h.8v6h-.8l-3.1-4.9V13z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.2,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 64
    },
    __self: this
  })), _path4 || (_path4 = React.createElement("path", {
    d: "M68.1 21.8c-2.3 0-4.2 1.9-4.2 4.3 0 2.3 1.9 4.2 4.3 4.2 2.3 0 4.2-1.9 4.2-4.2s-1.8-4.2-4.1-4.3c-.1-.1-.1-.1-.2 0zm0 6.8c-1.4.1-2.7-1-2.8-2.4s1-2.7 2.4-2.8 2.7 1 2.8 2.4v.2c.1 1.4-.9 2.5-2.4 2.6.1 0 .1 0 0 0zm-9.3-6.8c-2.3 0-4.2 1.9-4.2 4.3 0 2.3 1.9 4.2 4.3 4.2 2.3 0 4.2-1.9 4.2-4.2s-1.8-4.2-4.1-4.3c-.1-.1-.1-.1-.2 0zm0 6.8c-1.4.1-2.7-1-2.8-2.4s1-2.7 2.4-2.8 2.7 1 2.8 2.4v.2c.1 1.4-1 2.5-2.4 2.6zm-11.1-5.5v1.8H52c-.1.8-.4 1.6-1 2.3-.9.9-2.1 1.4-3.3 1.3-2.7 0-4.8-2.1-4.8-4.8s2.1-4.8 4.8-4.8c1.2 0 2.4.4 3.3 1.3l1.3-1.3c-1.2-1.2-2.8-1.9-4.5-1.9-3.6-.1-6.7 2.7-6.9 6.3-.1 3.6 2.7 6.7 6.3 6.9h.5c1.7.1 3.4-.6 4.6-1.8 1-1.2 1.6-2.7 1.6-4.2 0-.4 0-.8-.1-1.1zm45.4 1.4c-.5-1.6-2-2.6-3.6-2.7-2.2 0-4 1.8-4 4v.3c0 2.3 1.8 4.2 4.1 4.2h.2c1.4 0 2.8-.7 3.5-1.9l-1.4-1c-.4.7-1.2 1.2-2.1 1.2s-1.7-.5-2.1-1.3l5.7-2.3zm-5.9 1.4c-.1-1.3.9-2.4 2.2-2.5.7 0 1.3.3 1.6.9zM82.6 30h1.9V17.5h-1.9zm-3-7.3c-.6-.6-1.5-1-2.3-1-2.3.1-4.2 2.1-4 4.5.1 2.2 1.9 3.9 4 4 .9 0 1.7-.4 2.2-1h.1v.6c0 1.6-.9 2.5-2.3 2.5-1 0-1.8-.6-2.1-1.5l-1.6.7c.6 1.5 2.1 2.5 3.8 2.5 2.2 0 4-1.3 4-4.4V22h-1.7v.7zm-2.2 5.9c-1.4-.1-2.5-1.4-2.4-2.8.1-1.3 1.1-2.2 2.4-2.4 1.3.1 2.3 1.2 2.3 2.5v.1c.1 1.3-.9 2.5-2.2 2.6h-.1zm24.4-11.1h-4.5V30h1.9v-4.7h2.6c2.1.2 4-1.5 4.2-3.6s-1.5-4-3.6-4.2h-.6zm0 6h-2.6v-4.3h2.7c1.2 0 2.1 1 2.1 2.1s-1 2.2-2.2 2.2zm11.5-1.8c-1.4-.1-2.7.7-3.3 1.9l1.7.7c.3-.6 1-1 1.7-.9 1-.1 1.9.6 2 1.6v.1c-.6-.3-1.3-.5-1.9-.5-1.8 0-3.6 1-3.6 2.8.1 1.6 1.4 2.8 3 2.8h.1c1 .1 1.9-.4 2.4-1.2h.1v1h1.8v-4.8c-.1-2.2-1.8-3.5-4-3.5zm-.2 6.8c-.6 0-1.5-.3-1.5-1.1 0-1 1.1-1.3 2-1.3.6 0 1.2.1 1.7.4-.1 1.2-1 2.1-2.2 2zm10.6-6.5l-2.1 5.4h-.1l-2.2-5.4h-2l3.3 7.6-1.9 4.2h1.9l5.1-11.8zm-16.8 8h1.9V17.5h-1.9z",
    fill: "#fff",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 71
    },
    __self: this
  })), _path5 || (_path5 = React.createElement("path", {
    d: "M10.4 7.5c-.3.4-.5.9-.4 1.4V31c0 .5.1 1 .5 1.4l.1.1L23 20.1v-.3z",
    fill: "url(#prefix__a)",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 75
    },
    __self: this
  })), _path6 || (_path6 = React.createElement("path", {
    d: "M27 24.3l-4.1-4.1v-.3l4.1-4.1h.1l4.9 2.8c1.4.8 1.4 2.1 0 2.9l-4.9 2.8z",
    fill: "url(#prefix__b)",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 79
    },
    __self: this
  })), _path7 || (_path7 = React.createElement("path", {
    d: "M27.1 24.2L22.9 20 10.4 32.5c.6.5 1.5.5 2.1.1z",
    fill: "url(#prefix__c)",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 83
    },
    __self: this
  })), _path8 || (_path8 = React.createElement("path", {
    d: "M27.1 15.8L12.5 7.5c-.6-.5-1.5-.5-2.1 0L22.9 20z",
    fill: "url(#prefix__d)",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 84
    },
    __self: this
  })), _path9 || (_path9 = React.createElement("path", {
    d: "M27 24.1l-14.5 8.2c-.6.4-1.4.4-2 0l-.1.1.1.1c.6.4 1.4.4 2 0l14.6-8.3z",
    opacity: 0.2,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 85
    },
    __self: this
  })), _path10 || (_path10 = React.createElement("path", {
    d: "M10.4 32.3c-.3-.4-.5-.9-.5-1.4v.2c0 .5.1 1 .5 1.4zm21.6-11l-5 2.8.1.1 4.9-2.8c.6-.3.9-.8 1-1.4-.1.6-.5 1-1 1.3z",
    opacity: 0.12,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 89
    },
    __self: this
  })), _path11 || (_path11 = React.createElement("path", {
    d: "M12.5 7.6L32 18.7c.5.3.9.7 1 1.3-.1-.6-.4-1.2-1-1.4L12.5 7.5c-1.4-.8-2.5-.1-2.5 1.4V9c0-1.5 1.1-2.2 2.5-1.4z",
    fill: "#fff",
    opacity: 0.25,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 93
    },
    __self: this
  })));
}

var _default = ReactComponent;
exports["default"] = _default;